"use client";



import { SmartTableBody } from "./smart-table-body";
import { SmartTableHead } from "./smart-table-head";
import { useSmartTableModelContext } from "./smart-table-model-context";

export function SmartTableGrid<TData>() {
  const m = useSmartTableModelContext<TData>();
  const { fillViewport } = m;
  const { data, isLoading, error, filters, clientFilters, t, table, totalColumnWidth, Button, Loading, onFiltersChangeWithHistory, stickyIds, scrollContainerRef, handleTableScroll } = m;
  return (
    <>
      {error === null && data.length > 0 && (
        <div
          ref={scrollContainerRef}
          onScroll={handleTableScroll}
          className={`smart-table-scroll relative max-w-full ${fillViewport ? "h-[calc(100vh-19rem)] overflow-auto" : "h-auto overflow-x-auto"} rounded-md border`}
        >
          {isLoading && (
            <div className="absolute inset-0 z-10 flex items-center justify-center bg-background/60 backdrop-blur-sm">
              <Loading />
            </div>
          )}
          <style>{`
            .smart-table th, .smart-table td { user-select: text; }
            .smart-table .header-text, .smart-table .cell-text { user-select: text; cursor: text; }
          `}</style>
          {stickyIds.length > 0 && (
            <style>{`
              @media (max-width: 640px) {
                [data-sticky-col] { max-width: 120px; }
                [data-sticky-col]:nth-child(n+3) { display: none; }
              }
              .smart-table { border-collapse: separate !important; border-spacing: 0; }
              .smart-table th, .smart-table td { position: relative !important; }
              .smart-table thead th { z-index: 2; }
              .smart-table thead [data-sticky-col] { z-index: 3 !important; }
              .smart-table tbody [data-sticky-col] { z-index: 1 !important; }
            `}</style>
          )}
          <table
            className="smart-table caption-bottom text-sm"
            style={{
              tableLayout: "fixed",
              width: totalColumnWidth,
              minWidth: "100%",
            }}
          >
            <SmartTableHead />
            <SmartTableBody />
          </table>
          {table.getFilteredRowModel().rows.length === 0 &&
            (clientFilters.length > 0 || filters.length > 0) && (
              <div className="flex flex-col items-center justify-center gap-2 py-8 text-sm text-text-secondary">
                {t("table.empty.filtered")}
                {filters.length > 0 && (
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onFiltersChangeWithHistory([])}
                  >
                    {t("table.filters.clearAll")}
                  </Button>
                )}
              </div>
            )}
        </div>
      )}

    </>  );
}
